import { ActionItemDTO } from "../DTO/actionItemDTO";

export class ActionItem{
    public id!:number;
    public customerId!:number
    public moovInstanceId!:number;
    public userId?:number;
    public actionType!:number; //1=moov step instance approval, 2=moov instance collision; this also allows to identify the related object type like 'MoovInstance' or 'MoovStepInstance'
    public actionReferenceId?:string;
    public objectReferences?:string;
    public actionTaken:boolean=false;
    public actionTakenByUserId?:number;
    public actionTakenAt?:Date;
    public typeOfActionTaken?:string;
    public remarkForActionTaken?:string;
    public added?:Date;
    public edited?:Date;

    public static mapFromDTO(param:ActionItemDTO):ActionItem{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ActionItem();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.moovInstanceId = param.moovInstanceId;
            obj.userId = param.userId;
            obj.actionType = param.actionType;
            obj.actionReferenceId = param.actionReferenceId;
            obj.actionTaken = param.actionTaken;
            obj.actionTakenByUserId = param.actionTakenByUserId;
            if(param.actionTakenAt) obj.actionTakenAt = new Date(param.actionTakenAt);
            obj.typeOfActionTaken = param.typeOfActionTaken;
            obj.remarkForActionTaken = param.remarkForActionTaken;
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:ActionItem):ActionItemDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ActionItemDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.moovInstanceId = param.moovInstanceId;
            dto.userId = param.userId;
            dto.actionType = param.actionType;
            dto.actionReferenceId = param.actionReferenceId;
            dto.actionTaken = param.actionTaken;
            dto.actionTakenByUserId = param.actionTakenByUserId;
            if(param.actionTakenAt) dto.actionTakenAt = param.actionTakenAt.toISOString();
            dto.typeOfActionTaken = param.typeOfActionTaken;
            dto.remarkForActionTaken = param.remarkForActionTaken;
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.edited = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    get displayType(){
        switch(this.actionType){
            case 1:
                return "Approval";
            case 2:
                return "Collision";
            default:
                return undefined;
        }
    }
}